export const PLACEHOLDER_IMG = '';

export const placeholderImage = ref(PLACEHOLDER_IMG);
